function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M472,48c4.418,0,8,-3.582,8,-8V8c0,-4.418,-3.582,-8,-8,-8H8C3.582,0,0,3.582,0,8v32c0,4.418,3.582,8,8,8h16v384H8c-4.418,0,-8,3.582,-8,8v32c0,4.418,3.582,8,8,8h464c4.418,0,8,-3.582,8,-8v-32c0,-4.418,-3.582,-8,-8,-8h-16V48H472ZM464,448v16H16v-16H464ZM40,432V48h400v384H40ZM16,32V16h448v16H16Z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M224,64H64c-4.418,0,-8,3.582,-8,8v336c0,4.418,3.582,8,8,8h160c4.418,0,8,-3.582,8,-8V72C232,67.582,228.418,64,224,64ZM136,400H72v-96h64V400ZM136,288H72v-96h64V288ZM136,176H72V80h64V176ZM216,400h-64v-96h64V400ZM216,288h-64v-96h64V288ZM216,176h-64V80h64V176Z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M416,64H256c-4.418,0,-8,3.582,-8,8v336c0,4.418,3.582,8,8,8h160c4.418,0,8,-3.582,8,-8V72C424,67.582,420.418,64,416,64ZM328,400h-64v-96h64V400ZM328,288h-64v-96h64V288ZM328,176h-64V80h64V176ZM408,400h-64v-96h64V400ZM408,288h-64v-96h64V288ZM408,176h-64V80h64V176Z"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 31.748,
  y: 38.551,
  id: "e1_rectangle",
  width: 412.724,
  height: 72.567
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 30.236,
  y: 100.535,
  id: "e3_rectangle",
  width: 414.236,
  height: 104.315
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 30.236,
  y: 192.756,
  id: "e4_rectangle",
  width: 415.748,
  height: 114.898
});

function Svg823(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    fill: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "svgEditorBackground",
    x: 0,
    y: 0,
    width: 480,
    height: 480,
    style: {
      fill: "none",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("defs", {
    id: "svgEditorDefs"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svgEditorClosePathDefs",
    style: {
      stroke: "black",
      strokeWidth: 1
    }
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg823);
export default __webpack_public_path__ + "static/media/8_2_3.3834433c.svg";
export { ForwardRef as ReactComponent };